import './appFunctions.less'

class AppFunctionsController {
    constructor() {
        'ngInject';
    }
}

export const AppFunctionsComponent = {
    name: 'appFunctions',
    component: {
        template: `
            <h2>Key features in mobile app:</h2>
            <div class="app-functions-grid">
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-today.png" alt="Today screen" />
                        <span>Today</span>
                    </div>
                    <span>View all your medications scheduled for the day</span>
                </div>
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-progress.png" alt="Progress screen" />
                        <span>Progress</span>
                    </div>
                    <span>Get a reminder when it's time to take a medication and track how often you take your medications</span>
                </div>
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-medlist.png" alt="Med list screen" />
                        <span>Med list</span>
                    </div>
                    <span>View a complete list of all your medications</span>
                </div>
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-inbox.png" alt="Inbox screen" />
                        <span>Inbox</span>
                    </div>
                    <span>Get medication updates from your healthcare providers</span>
                </div>
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-careteam.png" alt="Care Team screen" />
                        <span>Care Team</span>
                    </div>
                    <span>View a list of all your healthcare providers and quickly share information with them</span>
                </div>
                <div class="app-function">
                    <div class="logo">
                        <img ng-src="/app/img/app-promote/icon-account.png" alt="Account screen" />
                        <span>Account</span>
                    </div>
                    <span>Quick and easy to manage your account and profiles</span>
                </div>
            </div>
        `,
        controller: AppFunctionsController,
        bindings: {
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/appFunctions/appFunctions.component.js